module.exports = __webpack_public_path__ + "lazerSlideLeft.png?bc6efc5cf09864a5149bbfa69d53dd9d";